export default __webpack_public_path__ + "static/media/01.e4a65b13.png";